import { baseAPI } from 'services/baseApi';

export const firebaseApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    connectToFirebase: builder.mutation({
      query: (payload) => ({
        url: '/notifications/subscribe-notification',
        method: 'POST',
        body: payload
      })
      // invalidatesTags: ['']
    })
  })
});

export const { useConnectToFirebaseMutation } = firebaseApi;
